<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
      </div>
    </div>

    

    <div class="imgBox2 min-w-1400">
      <div class="img2Box max-w-1400">
        <img :src="importedImg2" alt="" class="imgItem2" />
      </div>
    </div>
    <div class="imgBox3 min-w-1400">
      <div class="img3Box max-w-1400">
        <img :src="importedImg3" alt="" class="imgItem3" />
      </div>
    </div>
    <div class="imgBox4 min-w-1400">
      <div class="img4Box max-w-1400">
        <img :src="importedImg4" alt="" class="imgItem4" />
      </div>
    </div>
    <div class="imgBox5 min-w-1400">
      <div class="img5Box max-w-1400">
        <img :src="importedImg5" alt="" class="imgItem5" />
      </div>
    </div>

<div class="imgBox1-1 min-w-1400">
      <div class="img1Box max-w-1400">
        <section style="padding-bottom: 10px; padding:20px 200px; " class="service-section">
          <h2 class="service-title">International Trade</h2>
          <p class="service-subtitle">Our company's international trade operations have established a comprehensive commodity trading system spanning three major sectors—consumer goods, industrial equipment, and electronic technology—covering various tiers of global supply chains.</p>
          <!-- <p class="service-description">AAAAAAAA</p> -->

          <div  class="service-row">
            <article
              v-for="service in serviceList"
              :key="service.type"
              class="service-item"
            >
              <div style="display: flex; justify-content: center; align-items: center; text-align: center;" class="service-heading">
                
                <h3>{{ service.title }}</h3>
              </div>

              <div class="service-copy">
                <p style="text-align: center;" v-for="(text, index) in service.texts" :key="index">
                  {{ text }}
                </p>
              </div>
            </article>
          </div>
        </section>
      </div>
    </div>

    <div class="imgBox6 min-w-1400">
      <div class="img6Box max-w-1400">
        <img :src="importedImg6" alt="" class="imgItem6" />
      </div>
    </div>
    <!-- <div class="imgBox7 min-w-1400">
      <div class="img7Box max-w-1400">
        <img :src="importedImg7" alt="" class="imgItem7" />
      </div>
    </div> -->
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/hkchuanchuan/components/img/Group 2147203501.png";
import importedImg2 from "@/page/hkchuanchuan/components/img/3_2.png";
import importedImg3 from "@/page/hkchuanchuan/components/img/3_3.png";
import importedImg4 from "@/page/hkchuanchuan/components/img/3_4.png";
import importedImg5 from "@/page/hkchuanchuan/components/img/3_5.png";
import importedImg6 from "@/page/hkchuanchuan/components/img/3_6.png";
// import importedImg7 from "@/page/hkchuanchuan/components/img/2_7.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      importedImg5: importedImg5,
      importedImg6: importedImg6,
      serviceList: [
        {
          type: "code",
          title: "Textiles and Apparel",
          texts: ["Apparel: Encompasses a wide range of ready-to-wear garments, such as tops, trousers, skirts, outerwear, underwear, sportswear, and children's clothing—covering both everyday and functional attire.", "Footwear & Headwear: Footwear (including leather shoes, athletic shoes, boots, sandals, etc.) andheadwear/accessories (such as sun hats, formal hats, knit caps, headscarves, etc.).", "Home Textiles: Household textile products, including bedding sets, duvets and pillows, towels and bath towels, curtains, rugs, tablecloths, and other fabric furnishings for the home."],
        },
        {
          type: "cloud",
          title: "Industrial Equipment",
          texts: ["General machinery: such as pumps, valves, compressors, fans, speed reducers, industrial boilers, and other general auxiliary equipment.", "Construction machinery: including excavators, bulldozers, cranes, loaders, road rollers, concrete machinery, and similar equipment.", 'Machine tools: such as lathes, milling machines, grinding machines, drilling machines, machining centers, CNC cutting equipment, and other metalworking machinery.'],
        },
        {
          type: "security",
          title: "Electronics & Digital",
          texts: ['Home Appliances: Home appliances, including white goods, black goods, kitchen appliances, and various small home appliances.', "Digital Electronics: Consumer electronics, such as smartphones, tablets, cameras, smartwatches, game consoles, headphones, etc.", "Electronic Components: Such as resistors, capacitors, inductors, chips, connectors, sensors, display modules, printed circuit boards, and similar parts."],
        },
      ],
      // importedImg7: importedImg7,
      altText: "图片",
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox1,
.imgBox1-1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box,
.img7Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7 {
  width: 100%;
  margin: 0;
}

.service-section {
  box-sizing: border-box;
  padding: 52px 36px 80px;
  color: #333333;
  font-family: Arial, Helvetica, sans-serif;
}

.service-title {
  margin: 0;
  font-size: 32px;
  line-height: 1.3;
  font-weight: 700;
  text-align: center;
}

.service-subtitle {
  margin: 22px 0 0;
  font-size: 18px;
  line-height: 1.6;
  color: #777777;
  text-align: center;
}

.service-description {
  max-width: 1260px;
  margin: 8px auto 0;
  font-size: 18px;
  line-height: 1.55;
  color: #777777;
  text-align: center;
}

.service-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 80px;
  margin-top: 70px;
  
}

.service-item {
  min-width: 0;
  border: 1px solid #5d4eff;
  padding: 40px 30px;
  box-sizing: border-box;
}

.service-heading {
  display: flex;
  align-items: center;
  gap: 14px;
}

.service-icon {
  display: inline-flex;
  flex: 0 0 48px;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: #efecff;
}

.service-icon svg {
  width: 32px;
  height: 32px;
  fill: none;
  stroke: #6552ff;
  stroke-width: 2.2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.service-heading h3 {
  margin: 0;
  font-size: 20px;
  line-height: 1.3;
  font-weight: 700;
  color: #3d3d3d;
}

.service-copy {
  margin-top: 28px;
}

.service-copy p {
  margin: 0 0 30px;
  font-size: 18px;
  line-height: 1.55;
  color: #777777;
}

.service-copy p:last-child {
  margin-bottom: 0;
}


.img2Box{
  padding:200px;
}
.img3Box{
  padding: 0 200px 200px;
}

.img5Box{
  padding: 200px;
}

</style>
